module.exports = __webpack_public_path__ + "img/location.7c1bb9f5.svg";